module.exports = __webpack_public_path__ + "static/media/20.b442e570.png";